/* KIS Verzendgarantie auto-add (v2, na adversarieel review)
   Voegt de Verzendgarantie (variant 53194834903363, 3,95 EUR) automatisch toe zodra er
   een ander product in de winkelwagen zit.
   Regels:
   - maximaal 1 stuks in de wagen, altijd (quantity terug naar 1, dubbele regels opgeruimd)
   - verwijdert zichzelf weer als de garantie het enige item in de wagen is
   - haalt de klant de garantie bewust weg (verwijderknop of quantity 0), dan blijft die weg
     zolang deze winkelwagen bestaat (vlag in localStorage, gekoppeld aan het cart-token,
     geldt dus voor alle tabbladen; RESPECT_REMOVAL op false = altijd opnieuw toevoegen)
   - plus/min-knoppen van de garantieregel worden verborgen; verwijderen blijft mogelijk
   Werkt op alle add-paden (theme product-form/quick add, maison-upsells, Foxify, PageFly,
   kis-gratis-gift) door POSTs naar cart/add|change|update|clear te observeren via fetch én
   XMLHttpRequest, en daarna de wagen te reconciliëren via /cart.js. Bewuste verwijdering
   wordt synchroon uit de request zelf gelezen (geen race met navigatie).
   UI-refresh: m-cart-drawer.onCartDrawerUpdate() (drawer, opent m NIET geforceerd) +
   MinimogEvents 'cart-update' met eigen source (cart-pagina rerendert dan zelf).
   Noodstop zonder deploy: window.KIS_VG_DISABLED = true zetten (bv. via custom code). */
(function () {
  'use strict';

  var VARIANT_ID = 53194834903363;
  var PRODUCT_ID = 14972634038595;
  var HANDLE = 'shipping-insurance';
  var RESPECT_REMOVAL = true;
  var FLAG_PREFIX = 'kis-vg-verwijderd:';

  /* Infotekst onder de garantieregel, per gepubliceerde winkeltaal; de pagina-taal
     (html lang) bepaalt de keuze, onbekende talen vallen terug op Engels. */
  var INFO_TEXTS = {
    nl: 'Met deze optie krijg je extra gemak en service bij vermissing of schade',
    en: 'This option gives you extra convenience and service in case of loss or damage',
    de: 'Mit dieser Option erhältst du zusätzlichen Komfort und Service bei Verlust oder Beschädigung',
    fr: 'Avec cette option, vous bénéficiez de plus de confort et de service en cas de perte ou de dommage',
    es: 'Con esta opción obtienes mayor comodidad y servicio en caso de pérdida o daños',
    it: 'Con questa opzione ricevi maggiore comodità e assistenza in caso di smarrimento o danni',
    da: 'Med denne mulighed får du ekstra bekvemmelighed og service ved bortkomst eller skade',
    sv: 'Med det här tillvalet får du extra bekvämlighet och service vid förlust eller skada',
    pl: 'Ta opcja zapewnia dodatkową wygodę i obsługę w razie zaginięcia lub uszkodzenia',
    pt: 'Com esta opção tens mais comodidade e assistência em caso de extravio ou danos'
  };
  function infoText() {
    var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    return INFO_TEXTS[lang] || INFO_TEXTS.en;
  }

  var origFetch = window.fetch;
  var reconciling = false;
  var rerun = false;
  var timer = null;
  var lastCartItems = null;   /* laatste bekende items, voor line-index -> variant mapping */
  var memoryRemoved = false;  /* fallback als localStorage niet beschikbaar is */
  var cartToken = null;

  function disabled() { return window.KIS_VG_DISABLED === true; }

  /* --- verwijder-vlag: per winkelwagen (cart-token), gedeeld over alle tabbladen --- */
  function flagRemoved() {
    if (!RESPECT_REMOVAL) return false;
    if (memoryRemoved) return true;
    if (!cartToken) return false;
    try { return localStorage.getItem(FLAG_PREFIX + cartToken) === '1'; } catch (e) { return false; }
  }
  function setRemoved() {
    if (!RESPECT_REMOVAL) return;
    memoryRemoved = true;
    if (!cartToken) return;
    try {
      /* oude vlaggen van vorige wagens opruimen, dan de huidige zetten */
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf(FLAG_PREFIX) === 0 && k !== FLAG_PREFIX + cartToken) localStorage.removeItem(k);
      }
      localStorage.setItem(FLAG_PREFIX + cartToken, '1');
    } catch (e) { /* private mode: memoryRemoved dekt deze pagina */ }
  }
  function clearRemoved() {
    memoryRemoved = false;
    if (!cartToken) return;
    try { localStorage.removeItem(FLAG_PREFIX + cartToken); } catch (e) {}
  }

  /* --- locale-veilige endpoints uit het thema zelf --- */
  function route(name, fallback) {
    var r = (window.MinimogSettings && window.MinimogSettings.routes) || {};
    return (r[name] || fallback);
  }

  function isCartMutation(url) {
    if (!url) return false;
    try {
      var path = new URL(String(url), window.location.origin).pathname;
      return /(^|\/)cart\/(add|change|update|clear)(\.js|\.json)?$/.test(path);
    } catch (e) { return false; }
  }

  function checkOk(r) {
    if (!r.ok) throw new Error('kis-vg: cart api status ' + r.status);
    return r.json();
  }

  function getCart() {
    return origFetch.call(window, route('cart', '/cart') + '.js', {
      headers: { 'Accept': 'application/json' }
    }).then(checkOk);
  }

  /* Interne calls lopen via origFetch en triggeren dus nooit onze eigen observer */
  function addInsurance() {
    return origFetch.call(window, route('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
    }).then(checkOk);
  }

  function updateLines(updates) {
    return origFetch.call(window, route('cart_update_url', '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(checkOk);
  }

  function refreshUI() {
    try {
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
    } catch (e) { /* drawer uit of nog niet gedefinieerd */ }
    try {
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'kis-verzendgarantie' });
      }
    } catch (e) { /* stil falen, nooit de winkel breken */ }
  }

  function reconcile() {
    if (disabled()) return;
    if (reconciling) { rerun = true; return; }
    reconciling = true;

    getCart().then(function (cart) {
      cartToken = cart.token || cartToken;
      lastCartItems = cart.items || [];

      var insLines = [];
      var othersQty = 0;
      lastCartItems.forEach(function (it) {
        if (it.variant_id === VARIANT_ID) insLines.push(it);
        else othersQty += it.quantity;
      });
      var insQty = insLines.reduce(function (s, it) { return s + it.quantity; }, 0);

      if (insQty > 0) clearRemoved(); /* hij zit erin (bv. zelf teruggezet): vlag weg */

      if (othersQty > 0 && insQty === 0 && !flagRemoved()) {
        return addInsurance().then(function () {
          schedule(); /* verificatiepass: vangt o.a. dubbele add vanuit een tweede tabblad */
          return true;
        });
      }

      var updates = {};
      var changed = false;
      if (insQty > 0 && othersQty === 0) {
        /* garantie als enige item: weghalen (geen klant-actie, dus geen vlag) */
        insLines.forEach(function (it) { updates[it.key] = 0; });
        changed = true;
      } else if (insLines.length) {
        /* max 1 regel met quantity 1 */
        insLines.forEach(function (it, i) {
          var want = (i === 0) ? 1 : 0;
          if (it.quantity !== want) { updates[it.key] = want; changed = true; }
        });
      }
      if (changed) return updateLines(updates).then(function () { return true; });
      return false;
    }).then(function (didChange) {
      if (didChange) refreshUI();
    }).catch(function () {
      /* netwerk-/cartfout: state ongemoeid laten, volgende cart-actie probeert opnieuw */
    }).then(function () {
      reconciling = false;
      if (rerun) { rerun = false; schedule(); }
    });
  }

  function schedule() {
    if (disabled()) return;
    clearTimeout(timer);
    timer = setTimeout(reconcile, 250);
  }

  /* --- bewuste verwijdering synchroon uit de request lezen (vóór debounce/navigatie) ---
     Dekt: JSON {line,quantity} (theme cart.js/drawer), JSON {id,quantity} met line-key of
     variant-id, JSON/urlencoded updates[...]=0, FormData. Mist een exotisch pad, dan is
     het gevolg alleen dat de garantie later opnieuw wordt toegevoegd. */
  function bodySetsInsuranceToZero(body) {
    try {
      if (!body) return false;
      var data = null;
      if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{') data = JSON.parse(s);
        else {
          var p = new URLSearchParams(s); data = {};
          p.forEach(function (v, k) { data[k] = v; });
        }
      } else if (window.FormData && body instanceof FormData) {
        data = {};
        body.forEach(function (v, k) { data[k] = v; });
      } else if (window.URLSearchParams && body instanceof URLSearchParams) {
        data = {};
        body.forEach(function (v, k) { data[k] = v; });
      }
      if (!data) return false;

      var qty = ('quantity' in data) ? parseInt(data.quantity, 10) : NaN;
      /* {id: "<variant of line-key>", quantity: 0} */
      if (qty === 0 && data.id != null && String(data.id).indexOf(String(VARIANT_ID)) === 0) return true;
      /* {line: <1-based index>, quantity: 0} -> mappen via laatste bekende cartstand */
      if (qty === 0 && data.line != null && lastCartItems) {
        var it = lastCartItems[parseInt(data.line, 10) - 1];
        if (it && it.variant_id === VARIANT_ID) return true;
      }
      /* updates-object of updates[key]-velden */
      var updates = data.updates;
      if (updates && typeof updates === 'object') {
        for (var k in updates) {
          if (String(k).indexOf(String(VARIANT_ID)) === 0 && parseInt(updates[k], 10) === 0) return true;
        }
      }
      for (var key in data) {
        var m = /^updates\[(.+)\]$/.exec(key);
        if (m && m[1].indexOf(String(VARIANT_ID)) === 0 && parseInt(data[key], 10) === 0) return true;
      }
      return false;
    } catch (e) { return false; }
  }

  function observeMutation(url, body) {
    try {
      var path = new URL(String(url), window.location.origin).pathname;
      if (/(^|\/)cart\/(change|update)(\.js|\.json)?$/.test(path) && bodySetsInsuranceToZero(body)) {
        setRemoved(); /* klant haalt de garantie zelf weg: direct onthouden */
      }
    } catch (e) {}
  }

  /* fetch-observer: kijkt alleen mee, verandert niets aan de request */
  window.fetch = function (input, init) {
    var result = origFetch.apply(window, arguments);
    try {
      var url = (typeof input === 'string' || input instanceof URL) ? String(input) : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (String(method).toUpperCase() === 'POST' && isCartMutation(url)) {
        observeMutation(url, init && init.body);
        result.then(function () { schedule(); }, function () {});
      }
    } catch (e) { /* observer mag nooit een request breken */ }
    return result;
  };

  /* XHR-observer (Foxify/PageFly/oudere app-code gebruikt soms XMLHttpRequest) */
  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var xhrProto = window.XMLHttpRequest.prototype;
    var origOpen = xhrProto.open;
    var origSend = xhrProto.send;
    xhrProto.open = function (method, url) {
      try { this._kisVgInfo = { method: method, url: url }; } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    xhrProto.send = function (body) {
      try {
        var info = this._kisVgInfo;
        if (info && String(info.method).toUpperCase() === 'POST' && isCartMutation(info.url)) {
          observeMutation(info.url, body);
          this.addEventListener('loadend', function () { schedule(); });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  }

  /* Plus/min verbergen op de garantieregel (drawer én cart-pagina); de losse
     verwijderknop (m-cart-remove-button) blijft gewoon staan. De :has()-variant staat
     bewust in een eigen regel: oudere browsers laten anders de hele regel vallen. */
  function injectCss() {
    if (document.getElementById('kis-vg-css')) return;
    var el = document.createElement('style');
    el.id = 'kis-vg-css';
    el.textContent =
      '.m-cart-item[data-product-id="' + PRODUCT_ID + '"] m-quantity-input,' +
      '.m-cart-item[data-product-id="' + PRODUCT_ID + '"] .m-quantity' +
      '{ display: none !important; }\n' +
      '.m-cart-item:has(a[href*="/products/' + HANDLE + '"]) m-quantity-input' +
      '{ display: none !important; }\n' +
      '.kis-vg-info { font-size: 12px; line-height: 1.4; font-weight: 400; color: #73818E; margin: 2px 0 0; }';
    (document.head || document.documentElement).appendChild(el);
  }

  /* Infotekst als ECHTE tekst in de DOM (geen pseudo-element, geen link), zodat
     vertaal-apps zoals Transcy m kunnen meenemen. De drawer en cart-pagina renderen
     hun DOM opnieuw bij elke wijziging, dus we plaatsen m opnieuw waar hij ontbreekt. */
  var infoTimer = null;
  function ensureInfo() {
    try {
      var rows = document.querySelectorAll('.m-cart-item[data-product-id="' + PRODUCT_ID + '"]');
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].querySelector('.kis-vg-info')) continue;
        var title = rows[i].querySelector('.m-cart-item__title');
        if (!title) continue;
        var p = document.createElement('p');
        p.className = 'kis-vg-info';
        p.textContent = infoText();
        title.insertAdjacentElement('afterend', p);
      }
    } catch (e) { /* nooit de winkel breken */ }
  }
  function watchInfo() {
    ensureInfo();
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(infoTimer);
      infoTimer = setTimeout(ensureInfo, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (disabled()) return;
    injectCss();
    watchInfo();
    /* Reconcile bij laden: dekt niet-AJAX form-adds (redirect naar /cart), terugkeer
       uit checkout en oude sessies met scheve stand. */
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
